import React from 'react';

const CloseIconLarge: React.FC = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>cancel-large</title>
      <path
        d="M31.6,15.4 L15.4,31.6 M15.4,15.4 L31.7,31.7"
        stroke="currentColor"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default CloseIconLarge;
